import { ComponentProps, FC } from 'react'

import { IconArrowDown } from '~/components/ui/icons/arrow-down'
import { IconArrowUp } from '~/components/ui/icons/arrow-up'
import { twMerge } from '~/lib/utils'

type SeeMoreButtonProps = ComponentProps<'button'>

export const SeeMoreButton: FC<SeeMoreButtonProps> = ({
  className,
  ...props
}) => {
  return (
    <button
      className={twMerge('flex items-center gap-x-1', className)}
      {...props}
    >
      <span className="text-body-s-bold text-brand">{props.title}</span>
      {props.title === 'もっと見る' ? (
        <IconArrowDown color="brand" />
      ) : (
        <IconArrowUp color="brand" />
      )}
    </button>
  )
}
